module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-field cb-field--toggle",
    class: [{
      'cb-field--error': (!!_vm.errorMessage && !_vm.focussed)
    }, {
      'cb-field--focus': _vm.focussed && !_vm.readonly
    }]
  }, [_c('toggle-button', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    style: (_vm.themeColor),
    attrs: {
      "value": _vm._internalValue,
      "color": {
        checked: 'currentColor'
      },
      "role": "checkbox",
      "id": _vm.name,
      "aria-disabled": _vm.readonly,
      "disabled": _vm.readonly,
      "name": _vm.name
    },
    on: {
      "change": function($event) {
        _vm.change($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "cb-field__label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(" " + _vm._s(_vm.displayLabel) + "\n  ")]), _vm._v(" "), (_vm.errorMessageWrapper && !_vm.focussed) ? _c('div', {
    staticClass: "cb-textarea__error"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessageWrapper) + "\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4948522f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/form/Checkbox.vue
// module id = 205
// module chunks = 1 2 3 4 5 25 29 30 31 32 66 67